// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IRmIW","left":"styles_left__CQUDD","right":"styles_right__2dwhN","alert":"styles_alert__1Tatu"};